import { render, staticRenderFns } from "./RefundTradeModal.vue?vue&type=template&id=9fc20630"
import script from "./RefundTradeModal.vue?vue&type=script&lang=js"
export * from "./RefundTradeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports